const QUESTIONS = [
    "¿Cuántas horas pierdes a la semana cualificando leads, persiguiendo respuestas y dando seguimiento — tiempo que deberías estar usando para vender y cerrar?",
    "¿Cuántos leads buenos se te enfriaron el mes pasado porque no llegaste a tiempo, o porque el seguimiento se te alargó más de la cuenta?",
    "¿Cuántas operaciones cerró tu competencia el año pasado que deberías haber cerrado tú — solo porque ellos llegaron antes?",
];

export default function ThreeQuestions() {
    return (
        <section
            id="preguntas"
            data-testid="questions-section"
            className="bg-white py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[820px]">
                    <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        Tres preguntas.
                    </h2>
                    <p className="mt-4 font-serif-display italic text-lg md:text-2xl text-[#666666]">
                        Si te reconoces en alguna, este es tu lugar.
                    </p>
                </div>

                <div className="mt-20 md:mt-28 space-y-16 md:space-y-24">
                    {QUESTIONS.map((q, i) => (
                        <div
                            key={i}
                            data-testid={`question-${i}`}
                            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start"
                        >
                            <div className="md:col-span-2">
                                <p className="font-serif-display text-5xl md:text-6xl text-[#8B6914] leading-none">
                                    {String(i + 1).padStart(2, "0")}.
                                </p>
                            </div>
                            <p className="md:col-span-10 font-serif-display text-2xl md:text-3xl lg:text-4xl text-[#1A1A1A] leading-[1.3] max-w-[920px]">
                                {q}
                            </p>
                        </div>
                    ))}
                </div>

                <p className="mt-20 md:mt-28 font-serif-display italic text-lg md:text-xl text-[#666666]">
                    Si has respondido alguna, este es tu lugar.
                </p>
            </div>
        </section>
    );
}
